import posthog from 'posthog-js'
import type { User } from '@/types'

const POSTHOG_PROJECT_TOKEN = 'phc_xGsDHHSLL73czKaej3bHTPUZGUoELk2zRtPEjQNmssR5'
const POSTHOG_HOST = 'https://eu.i.posthog.com'

const isEnabled = import.meta.env.PROD

export function startAnalytics(): void {
	if (!isEnabled) return
	posthog.init(POSTHOG_PROJECT_TOKEN, {
		api_host: POSTHOG_HOST,
		defaults: '2026-08-30',
		person_profiles: 'identified_only',
		session_recording: { maskAllInputs: true },
	})
}

export function identifyUser(user: User): void {
	if (!isEnabled) return
	posthog.identify(user.id, { name: user.name, role: user.role })
}

export function forgetUser(): void {
	if (!isEnabled) return
	posthog.reset()
}
